import React from "react";
import { Box, Toolbar, type SxProps, type Theme } from "@mui/material";
import { Outlet } from "react-router-dom";
import { MOBILE_BOTTOM_NAV_OFFSET } from "../footer/MobileFooterView";

type LayoutMainProps = {
  /** When true, reserve space so content clears the fixed bottom nav. */
  showBottomNav?: boolean;
  sx?: SxProps<Theme>;
};

/**
 * Shared page shell for User / Talent / Guest layouts.
 * Bottom spacing for the mobile nav lives here — not in individual pages.
 */
const LayoutMain: React.FC<LayoutMainProps> = ({ showBottomNav = false, sx }) => (
  <Box
    component="main"
    sx={{
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      height: "100dvh",
      minHeight: 0,
      minWidth: 0,
      px: { xs: 1, md: 3 },
      pt: 3,
      overflow: "hidden",
      bgcolor: "var(--page-bg)",
      ...((sx as object) || {}),
    }}
  >
    <Toolbar />
    <Box
      sx={{
        flexGrow: 1,
        minHeight: 0,
        minWidth: 0,
        width: "100%",
        overflow: "auto",
      }}
    >
      {/*
        Padding on a flex scroller is unreliable across browsers.
        Wrap the outlet so the bottom gap is part of the scroll content.
      */}
      <Box
        sx={{
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          pb: showBottomNav ? MOBILE_BOTTOM_NAV_OFFSET : 3,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  </Box>
);

export default LayoutMain;
